import { Builder } from '@builder.io/react';

import FeaturesSideBySideImage from './index.tsx';

Builder.registerComponent(FeaturesSideBySideImage, {
  name: 'FeaturesSideBySideImage',
  inputs: [
    {
      name: 'features',
      type: 'list',
      subFields: [
        {
          name: 'overtitle',
          type: 'string'
        },
        { name: 'gradient', type: 'boolean', defaultValue: true },
        {
          name: 'title',
          type: 'string'
        },
        {
          name: 'description',
          type: 'richText'
        },
        {
          name: 'bullets',
          type: 'list',
          subFields: [
            { name: 'title', type: 'string' },
            { name: 'text', type: 'string' }
          ]
        },
        {
          name: 'link',
          type: 'object',
          subFields: [
            { name: 'href', text: 'string' },
            { name: 'name', type: 'string' }
          ]
        },
        { name: 'useVideo', type: 'boolean', defaultValue: false },
        {
          showIf: `!options.get('useVideo')`,
          name: 'image',
          type: 'object',
          subFields: [
            {
              name: 'src',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            {
              name: 'epigraph',
              type: 'string',
              defaultValue: 'Epigraph'
            },
            {
              name: 'width',
              type: 'number'
            },
            {
              name: 'height',
              type: 'number'
            },
            {
              name: 'alt',
              type: 'string'
            }
          ]
        },
        {
          showIf: `options.get('useVideo')`,
          name: 'video',
          type: 'object',
          subFields: [
            {
              name: 'src',
              type: 'string',
              defaultValue: 'https://stream.mux.com/aU5MGkW79Jk400UFz6pqDKlzOYUOiWwAO.m3u8'
            },
            {
              name: 'poster',
              type: 'file',
              allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
            },
            { name: 'width', type: 'number', defaultValue: 1920 },
            { name: 'height', type: 'number', defaultValue: 1080 },
            { name: 'autoplay', type: 'boolean', defaultValue: true },
            { name: 'controls', type: 'boolean', defaultValue: false },
            { name: 'loop', type: 'boolean', defaultValue: true },
            { name: 'muted', type: 'boolean', defaultValue: false }
          ]
        }
      ]
    }
  ]
});
